import React, { useState, useEffect, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cogoToast from 'cogo-toast';
import _ from 'lodash';
import cn from 'classnames';
import './CallToDealMatchingModal.scss';

import Loader from '../General/Loader';

import { updateCall } from '../../actions/CallsActions';

import Modal from './Modal';

const CallToDealMatchingModal = (props) => {
  const { call, visible, close } = props;
  const [searchVal, setSearchVal] = useState('');
  const [matchingToDeal, setMatchingToDeal] = useState(null);
  const searchRef = useRef();

  const deals = props.deals?.allDeals;
  const filteredDeals = _.filter(deals, (d) => !d.is_closed && d.name.toLowerCase().includes(searchVal.toLowerCase()));
  const orderedDeals = _.orderBy(filteredDeals, 'name'); // _.get(_.orderBy(deal.chats, 'createdAt'), '0.createdAt'));

  const matchDeal = async (deal) => {
    if (matchingToDeal) return cogoToast.warn('Matching already in process.');
    setMatchingToDeal(deal);
    props
      .updateCall(call, { deal_id: deal.id })
      .then((resp) => {
        if ('call' in resp) {
          setSearchVal('');
          close();
          cogoToast.success(`Successfully matched call to ${deal.name}`);
        } else {
          cogoToast.error('Had an error matching this call to a deal, please try again.');
        }
      })
      .finally(() => {
        setMatchingToDeal(null);
      });
  };

  useEffect(() => {
    visible && searchRef.current && !isMobile && searchRef.current.focus();
  }, [visible]);

  return (
    <Modal visible={!!call} close={close} showClose className='call-to-deal-matching-modal'>
      <div className='controls'>
        <input ref={searchRef} placeholder={`Find Deal for ${call?.chat_name}`} value={searchVal} onChange={(e) => setSearchVal(e.target.value)} />
      </div>
      <div className='deal-rows'>
        {orderedDeals.map((deal, idx) => {
          const matching = matchingToDeal?.id === deal.id;
          const matched = call?.deal?.id === deal.id;
          return (
            <div onClick={() => matchDeal(deal)} key={deal.id} className='deal-row'>
              <div className='main'>
                <div className='name'>{deal.name}</div>
                {/* <div className='subtitle'>Last Call 3/3/21</div> */}
              </div>
              <div className='actions'>
                <div className={cn('action match', { matching, matched })}>
                  {matched ? 'Matched' : 'Match'}
                  {matching && <Loader size={40} />}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Modal>
  );
};

CallToDealMatchingModal.propTypes = {
  call: PropTypes.object,
  close: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { brands } = state;
  return { brands };
};

export default connect(mapStateToProps, {
  updateCall,
})(CallToDealMatchingModal);
